// src/components/DescripcionEditor.jsx
import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Estilos del editor

const EditorNovelas = ({ value, onChange }) => {
  return (
    <div style={{ padding: '1rem' }}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={{
          toolbar: [
            [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ align: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link', 'image'],
            ['clean'],
          ],
        }}
        formats={[
          'header',
          'bold', 'italic', 'underline', 'strike',
          'align',
          'list', 'bullet',
          'link', 'image'
        ]}
        placeholder="Escribe una descripción detallada..."
      />
    </div>
  );
};

export default EditorNovelas;
